const endpoints = {
  TEST: "/events/send-test-invitation",
}

export default endpoints
